import { useEffect, useState } from "react"


export interface VideoProps {
    url ?: string
}

export const Video: React.FC<VideoProps> = (props: VideoProps) => {
    const [video, setVideo] = useState<VideoProps | null>();
    
    useEffect(() => {
        if (props.url == undefined) {
            return 
        }
        
        setVideo(props)

    }, [props])

    return(
        !video ? <></> : <video autoPlay muted loop controls width="50%" height="500px"  src={video?.url} />
    )
}